import * as React from 'react';
import { Color, ColorStatus } from '_helpers';
import { useEffectProcessing, useMultiSearch } from 'hooks';
import { Card, MultiRowColumn, SimpleTable } from '../../index';
import { MappedExpertChangeRequestType } from '../../enums';
import { IApiError, IExpertChangeRequests } from '../../models';
import { IFromToDatePart, IFullSearchPart, IIdFilter } from '../../reduxModels';
import { PaginationImpl } from '../../defaultValues';

const ChangesHistoryTab: React.FC<IProps> = (props) => {
    const { filters, changeFilter } = useMultiSearch<IIdFilter & IFullSearchPart & IFromToDatePart>(props.getExpertChangeRequestsHistory, { id: props.expertId });
    const processing = useEffectProcessing(
      () => props.getExpertChangeRequestsHistory(filters),
      [],
      () => props.clearExpertChangeRequestsHistory(),
    );

    const tableHeader = React.useMemo(() => ([
        { title: 'ДАТА', columnStyles: { width: '10%' } },
        { title: 'ВНЕСЕННОЕ ИЗМЕНЕНИЕ', columnStyles: { width: '40%' } },
        { title: 'ПРОЦЕСС ИЗМЕНЕНИЯ', columnStyles: { width: '50%' } },
    ]), []);

    const tableRows = React.useMemo(() => (props.expertChanges ? props.expertChanges.items.map(ec => ({
        id: ec.id,
        columns: [
            ec.dateTime.format('DD.MM.YYYY'),
            <MultiRowColumn
              rows={[
                  MappedExpertChangeRequestType[ec.requestType],
                  ec.attestationSubCommissionName,
                  ec.newExpertStatus,
              ]}
            />,
            ec.approvals.map(c => (
                <div style={{fontSize: '0.75rem'}}>{c}</div>
            )),
        ],
    })) : []), [props.expertChanges]);

    return (
      <Card
        withoutBorder
        withoutPadding
        showLoader={processing}
        show404Error={!!props.apiError}
        title={props.title || 'История назначений'}
        category={props.category || 'История включений/исключений из составов комиссий'}
      >

          <SimpleTable
            tableRows={tableRows}
            tableHeaders={tableHeader}
            handleRowClick={() => true}
            pagination={new PaginationImpl(props.expertChanges).getPaginationData()}
            onPagination={p => changeFilter({
                pageSize: p.perPage,
                page: p.page,
            })}
          />
      </Card>
    );
};

interface IProps {
    title?: string;
    category?: string;
    expertChanges: IExpertChangeRequests | null;
    expertId?: string;
    apiError: IApiError | null;
    getExpertChangeRequestsHistory: (payload: IIdFilter & IFullSearchPart & IFromToDatePart) => Promise<void>;
    clearExpertChangeRequestsHistory: () => void;
}

export default ChangesHistoryTab;
